import React from 'react';
import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import {Toaster} from 'react-hot-toast';
import {AuthProvider, useAuth} from './context/AuthContext';
import AppLayout from './components/layout/AppLayout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import TicketListPage from './pages/TicketListPage';
import TicketCreatePage from './pages/TicketCreatePage';
import TicketDetailPage from './pages/TicketDetailPage';
import AdminConfigPage from './pages/AdminConfigPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import ClientUsersPage from './pages/ClientUsersPage';
import HolidayCalendarPage from './pages/HolidayCalendarPage';
import UsageManualPage from './pages/UsageManualPage';

function ProtectedRoute({children}) {
    const {user, loading} = useAuth();
    if (loading) {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                color: '#6b7280'
            }}>
                Loading...
            </div>
        );
    }
    return user ? children : <Navigate to="/login" replace/>;
}

function AppRoutes() {
    const {user, loading} = useAuth();

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                color: '#6b7280'
            }}>
                Loading...
            </div>
        );
    }

    return (
        <Routes>
            {/* Public */}
            <Route path="/login" element={user ? <Navigate to="/dashboard" replace/> : <LoginPage/>}/>
            <Route path="/auth/callback" element={<LoginPage/>}/>

            {/* Protected - inside layout */}
            <Route element={<ProtectedRoute><AppLayout/></ProtectedRoute>}>
                <Route path="/dashboard" element={<DashboardPage/>}/>
                <Route path="/tickets" element={<TicketListPage/>}/>
                <Route path="/tickets/new" element={<TicketCreatePage/>}/>
                <Route path="/tickets/:id" element={<TicketDetailPage/>}/>
                {/* Placeholder routes for later phases */}
                <Route path="/admin/metadata" element={<AdminConfigPage/>}/>
                <Route path="/info/calendar" element={<HolidayCalendarPage/>}/>
                <Route path="/info/manual" element={<UsageManualPage/>}/>
                <Route path="/change-password" element={<ChangePasswordPage/>}/>
                <Route path="/admin/client-users" element={<ClientUsersPage />} />

            </Route>

            {/* Default redirect */}
            <Route path="*" element={<Navigate to="/dashboard" replace/>}/>
        </Routes>
    );
}


export default function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <Toaster
                    position="top-right"
                    toastOptions={{
                        duration: 3000,
                        style: {fontSize: 13, borderRadius: 8},
                    }}
                />
                <AppRoutes/>
            </AuthProvider>
        </BrowserRouter>
    );
}
